import * as Types from '../../@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type KidsWorldVideoListQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type KidsWorldVideoListQuery = { __typename?: 'Query', kidsWorldVideoList: Array<{ __typename?: 'KidsWorldVideoInfoResult', kidsWorldVideoId: number, yearAndMonth: string, title1: string, vimeoId1: string, vimeoVideoUrl1: string, title2: string, vimeoId2: string, vimeoVideoUrl2: string, title3: string, vimeoId3: string, vimeoVideoUrl3: string, title4: string, vimeoId4: string, vimeoVideoUrl4: string, title5: string, vimeoId5: string, vimeoVideoUrl5: string }> };


export const KidsWorldVideoListDocument = gql`
    query KidsWorldVideoList {
  kidsWorldVideoList {
    kidsWorldVideoId
    yearAndMonth
    title1
    vimeoId1
    vimeoVideoUrl1
    title2
    vimeoId2
    vimeoVideoUrl2
    title3
    vimeoId3
    vimeoVideoUrl3
    title4
    vimeoId4
    vimeoVideoUrl4
    title5
    vimeoId5
    vimeoVideoUrl5
  }
}
    `;

/**
 * __useKidsWorldVideoListQuery__
 *
 * To run a query within a React component, call `useKidsWorldVideoListQuery` and pass it any options that fit your needs.
 * When your component renders, `useKidsWorldVideoListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKidsWorldVideoListQuery({
 *   variables: {
 *   },
 * });
 */
export function useKidsWorldVideoListQuery(baseOptions?: Apollo.QueryHookOptions<KidsWorldVideoListQuery, KidsWorldVideoListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KidsWorldVideoListQuery, KidsWorldVideoListQueryVariables>(KidsWorldVideoListDocument, options);
      }
export function useKidsWorldVideoListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KidsWorldVideoListQuery, KidsWorldVideoListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KidsWorldVideoListQuery, KidsWorldVideoListQueryVariables>(KidsWorldVideoListDocument, options);
        }
export type KidsWorldVideoListQueryHookResult = ReturnType<typeof useKidsWorldVideoListQuery>;
export type KidsWorldVideoListLazyQueryHookResult = ReturnType<typeof useKidsWorldVideoListLazyQuery>;
export type KidsWorldVideoListQueryResult = Apollo.QueryResult<KidsWorldVideoListQuery, KidsWorldVideoListQueryVariables>;